<template>
  <v-menu
    v-if="columnValueList(header.value).length > 1"
    bottom
    right
    offset-y
    :close-on-content-click="false"
  >
    <template #activator="{ on, attrs }">
      <v-btn icon v-bind="attrs" v-on="on">
        <v-icon v-if="value.length > 0">
          mdi-filter
        </v-icon>
        <v-icon v-else>
          mdi-filter-outline
        </v-icon>
      </v-btn>
    </template>
    <v-container fluid class="white">
      <v-checkbox
        v-for="(check, key) in columnValueList(header.value)"
        :key="header.value + '_' + key"
        v-model="filter"
        dense
        hide-details
        :label="check"
        :value="check"
      />
    </v-container>
  </v-menu>
</template>

<script>
export default {
   props: {
      items: {
         type: Array,
         required: true,
      },
      header: {
         type: Object,
         required: true,
      },
      value: {
         type: Array,
         default: function () {
            return []
         }
      }
   },
   data () {
      return {
         filter: []
      }
   },
   watch: {
      filter (newVal) {
         this.$emit('input', newVal)
      }
   },
   methods: {
      columnValueList (val) {
         const list = this.items
            .map((item) => item[val])
            .filter(
               (value, index, self) => self.indexOf(value) === index && value !== ''
            )
         return list
      },
   },
}
</script>

<style>

</style>
